(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('ng-metadata/core'), require('angular')) :
	typeof define === 'function' && define.amd ? define(['exports', 'ng-metadata/core', 'angular'], factory) :
	(factory((global['wildcards-components'] = {}),global.core,global.angular));
}(this, (function (exports,core,angular$1) { 'use strict';

var __decorate$3 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$2 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var WildcardConfig = /** @class */ (function () {
    function WildcardConfig() {
        this.API_BASE_URL = '';
        this.APP_ENV = '';
        this.FB_APP_ID = '';
        if (window.location.hostname === 'latest.staging.meltwater.net' || window.location.hostname === 'localhost') {
            this.API_BASE_URL = 'https://latest.staging.meltwater.net/instagram-api';
            this.APP_ENV = 'staging';
            this.FB_APP_ID = '2038074726483303';
        }
        else if (window.location.hostname === 'staging.meltwater.net') {
            this.API_BASE_URL = 'https://staging.meltwater.net/instagram-api';
            this.APP_ENV = 'staging';
            this.FB_APP_ID = '2038074726483303';
        }
        else if (window.location.hostname === 'app.meltwater.com') {
            this.API_BASE_URL = 'https://app.meltwater.com/instagram-api';
            this.APP_ENV = 'prod';
            this.FB_APP_ID = '1525366670903016';
        }
        else {
            // this.API_BASE_URL = 'https://local-api.expion.sysomos.com:3001';
            this.API_BASE_URL = 'https://latest.staging.meltwater.net/instagram-api';
            this.APP_ENV = 'dev';
            this.FB_APP_ID = '2038074726483303';
        }
    }
    WildcardConfig = __decorate$3([
        core.Injectable(),
        __metadata$2("design:paramtypes", [])
    ], WildcardConfig);
    return WildcardConfig;
}());

var __decorate$2 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param$1 = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var InstagramService = /** @class */ (function () {
    function InstagramService($http) {
        var _this = this;
        this.$http = $http;
        // API_BASE_URL = 'https://cevj6d57bd.execute-api.us-east-1.amazonaws.com/Prod';
        // API_BASE_URL = 'https://local-api.expion.sysomos.com:3001'
        // Release api
        this.API_BASE_URL = '';
        this.AUTH_URL = '/api/auth';
        this.ACTIVITY_URL = '/api/activity';
        this.PAGES_URL = '/api/pages';
        this.TOKENS_URL = '/api/tokens';
        this.HASHTAGS_URL = '/api/hashtags';
        this.wildcardConfig = new WildcardConfig();
        this.getHeaders = function () {
            // uncomment for release
            if (_this.wildcardConfig.APP_ENV !== 'dev') {
                return {};
            }
            else {
                // uncomment in dev mode for now
                return {
                    'authorization': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ1c2VyIjp7Il9pZCI6IjViZDM0ZTFkZWQxZTIwN2I2OGIzZWFhYSIsImZpc' +
                        'nN0TmFtZSI6IlNhdXJhYiIsImxhc3ROYW1lIjoiUGFydXRoaSIsImVtYWlsIjoic2F1cmFiLnBhcnV0aGlAbWVsdHdhdGVyLmNvbSIsInRpbWV6b25l' +
                        'IjoiQW1lcmljYS9OZXdfWW9yayIsImxhbmd1YWdlIjoiZW4iLCJhY3RpdmVDb21wYW55SWQiOiI1YmQzMzhiOGVkMWUyMDdiNjhiM2VhYTgiLCJpc0l' +
                        'udGVybmFsIjp0cnVlLCJwYXNzd29yZCI6IiQyYSQxMCQua001N2NQb2NueUpwZDZ0WGhtOVJ1M296aWtGSzAwMkFaUmt5VjJUaDJETTFZclc5S25JbS' +
                        'IsImNyZWF0ZWQiOiIyMDE4LTEwLTI2VDE3OjI1OjQ5LjYyNloiLCJtb2RpZmllZCI6IjIwMTgtMTEtMTNUMjA6NTg6NTkuNjIxWiJ9LCJjb21wYW55Ij' +
                        'p7Il9pZCI6IjViZDMzOGI4ZWQxZTIwN2I2OGIzZWFhOCIsIm5hbWUiOiJKYXJlZCBGJ3MgQ29tcGFueSIsImNvdW50cnkiOiJ1cyIsImNyZWF0ZWQiO' +
                        'iIyMDE4LTEwLTI2VDE1OjU0OjMyLjI3MFoiLCJtb2RpZmllZCI6IjIwMTgtMTAtMjlUMTQ6NDA6MzguNjQ0WiJ9LCJleHAiOjE1NDIyMjkxNDAxNDd9' +
                        '.AfZpRcPeIInAkguIVTzgkEan4Kp_Xn2cD1nmh7tOUxn9eCCAJV-Fh7iLPgOvlmTJMDneJGqVCo0-n3eg1quSUjqvTS-vOsz1zQ3OUX9VocKqbnnQ42' +
                        '03hXVmHWmW1bboPAHIE3Ka6nNc5GNKR51P1e2-DV0kVECFgqHOnplG2wHWx6G07rKvvt2n2EbRjCFr8NnGkBjZf377V6wWTDdA-HVNi7uA4LvJZrqOa' +
                        'cQAsfRfyG4YOEJE8fvCWVQfkhDUUvJ8lSl6EOMd1lPHRxAzF0O4cZf7gwJWcY0FPW3Ldc9Y-L1mgxu4VDE_7B9Cn8y4IkGTewu-lqwgmq6ICDKaog'
                };
                // return {'authorization': 'e38c0e05-9cd3-4e5a-9951-43e5a45f0b02','app':'sysomos'};
            }
        };
        this.API_BASE_URL = this.wildcardConfig.API_BASE_URL;
    }
    InstagramService.prototype.getConnectedSources = function (index) {
        var activityIndex = '';
        if (index) {
            activityIndex = index;
        }
        return this.$http.get(this.API_BASE_URL + this.TOKENS_URL, {
            headers: this.getHeaders(),
            params: { next: activityIndex }
        });
    };
    InstagramService.prototype.saveFacebookToken = function (data) {
        return this.$http.post(this.API_BASE_URL + this.TOKENS_URL, data, { 'headers': this.getHeaders() });
    };
    // public saveTrackedProfile(data) {
    //     return this.$http.post(this.API_BASE_URL + this.PROFILES_URL, data, {'headers': this.getHeaders()});
    // }
    InstagramService.prototype.auth = function (fbUserId, fbAccessToken, index) {
        var authIndex = '';
        if (index) {
            authIndex = index;
        }
        var queryString = '?fbUserId=' + fbUserId + '&fbAccessToken=' + fbAccessToken;
        return this.$http.get(this.API_BASE_URL + this.AUTH_URL + queryString, {
            'headers': this.getHeaders(), params: { next: authIndex }
        });
    };
    InstagramService.prototype.getPagesForCurrentCompany = function (index) {
        return this.$http.get(this.API_BASE_URL + this.PAGES_URL, { 'headers': this.getHeaders() });
    };
    InstagramService.prototype.getActivityLog = function (index) {
        var activityIndex = '';
        if (index) {
            activityIndex = index;
        }
        return this.$http.get(this.API_BASE_URL + this.ACTIVITY_URL, {
            'headers': this.getHeaders(), params: { next: activityIndex }
        });
    };
    InstagramService.prototype.getActivityLogByPageID = function (pageID, index) {
        if (pageID) {
            var activityIndex = '';
            if (index) {
                activityIndex = index;
            }
            return this.$http.get(this.API_BASE_URL + this.ACTIVITY_URL + '?page_id=' + pageID, {
                'headers': this.getHeaders(), params: { next: activityIndex }
            });
        }
    };
    InstagramService.prototype.addPost = function (postBody) {
        return this.$http.post(this.API_BASE_URL + this.PAGES_URL, postBody, { 'headers': this.getHeaders() });
    };
    // public addProfileToPage(profileId, pageId) {
    //     let profileObj = {
    //         'page_id': pageId,
    //         'business_profile_id': profileId
    //     }
    //     return this.$http.post(this.API_BASE_URL + this.PROFILES_URL, profileObj, {'headers': this.getHeaders()});
    // }
    InstagramService.prototype.getHashtagsForPage = function (pageId) {
        var url = this.API_BASE_URL + "/api/pages/" + pageId + "/hashtags";
        return this.$http.get(url, { 'headers': this.getHeaders() });
    };
    InstagramService.prototype.addHashtagToPage = function (hashtagId, pageId) {
        var hashtagObj = {
            'page_id': pageId,
            'hashtag': hashtagId
        };
        return this.$http.post(this.API_BASE_URL + this.HASHTAGS_URL, hashtagObj, { 'headers': this.getHeaders() });
    };
    InstagramService.prototype.removePage = function (pageId) {
        return this.$http.delete(this.API_BASE_URL + this.PAGES_URL + '/' + pageId, { 'headers': this.getHeaders() });
    };
    InstagramService.prototype.getItemsForPage = function (pageId, itemType) {
        var url = this.API_BASE_URL + "/api/items?pageId=" + pageId + "&itemType=" + itemType;
        return this.$http.get(url, { 'headers': this.getHeaders() });
    };
    InstagramService.prototype.validate = function (pageId, itemType, itemValue) {
        var url = this.API_BASE_URL + "/api/validate?pageId=" + pageId + "&itemType=" + itemType + "&itemValue=" + itemValue;
        return this.$http.get(url, { 'headers': this.getHeaders() });
    };
    InstagramService.prototype.addItem = function (pageId, itemType, itemValue) {
        var url = this.API_BASE_URL + "/api/add_item";
        return this.$http.post(url, { pageId: pageId, itemType: itemType, itemValue: itemValue }, { 'headers': this.getHeaders() });
    };
    InstagramService.prototype.saveItems = function (pageId, itemType, itemValues) {
        var obj = {
            'pageId': pageId,
            'itemType': itemType,
            'itemValues': itemValues
        };
        var url = this.API_BASE_URL + "/api/items";
        return this.$http.post(url, obj, { 'headers': this.getHeaders() });
    };
    InstagramService.prototype.updateToken = function (pageId, fbUserId, fbAccessToken) {
        var obj = {
            'pageId': pageId,
            'fbUserId': fbUserId,
            'fbAccessToken': fbAccessToken
        };
        var url = "" + this.API_BASE_URL + this.TOKENS_URL;
        return this.$http.post(url, obj, { 'headers': this.getHeaders() });
    };
    InstagramService = __decorate$2([
        core.Injectable(),
        __param$1(0, core.Inject('$http')),
        __metadata$1("design:paramtypes", [Object])
    ], InstagramService);
    return InstagramService;
}());

var __decorate$1 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var InstagramSourcesComponent = /** @class */ (function () {
    function InstagramSourcesComponent($scope, $mdDialog, $timeout, $mdMedia, $mdToast, $window, $http, $translate, $q, instagramService) {
        'ngInject';
        var _this = this;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.$timeout = $timeout;
        this.$mdMedia = $mdMedia;
        this.$mdToast = $mdToast;
        this.$window = $window;
        this.$http = $http;
        this.$translate = $translate;
        this.$q = $q;
        this.instagramService = instagramService;
        this.sources = [];
        this.status = 'loading';
        this.wildcardConfig = new WildcardConfig();
        this.descriptionText = {
            title: '',
            bullets: []
        };
        this.activityIndex = '';
        // mw-menu-item threw errors with translate directive.
        this.hamburgerMenuItems = [
            {
                name: 'Manage Competitors',
                onClick: function ($event, pageId) {
                    _this.$mdDialog.show({
                        parent: angular$1.element(document.body),
                        targetEvent: $event,
                        clickOutsideToClose: true,
                        template: '<wc-instagram-manage-items [config] = "config"></wc-instagram-manage-items>',
                        locals: {
                            config: {
                                pageId: pageId,
                                itemType: 'profiles',
                                name: 'Business Profiles'
                            }
                        },
                        controller: ['$scope', '$mdDialog', 'config', DialogController]
                    }).then(function () {
                        _this.getPages();
                    });
                    function DialogController($scope, $mdDialog, config) {
                        $scope.config = config;
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        };
                    }
                }
            }, {
                name: 'Manage Hashtags',
                onClick: function ($event, pageId) {
                    _this.$mdDialog.show({
                        parent: angular$1.element(document.body),
                        targetEvent: $event,
                        clickOutsideToClose: true,
                        template: '<wc-instagram-manage-items [config] = "config"></wc-instagram-manage-items>',
                        locals: {
                            config: {
                                pageId: pageId,
                                itemType: 'hashtags',
                                name: 'Hashtags'
                            }
                        },
                        controller: ['$scope', '$mdDialog', 'config', DialogController]
                    }).then(function () {
                        _this.getPages();
                    });
                    function DialogController($scope, $mdDialog, config) {
                        $scope.config = config;
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        };
                    }
                }
            }, {
                name: 'Disconnect',
                onClick: function ($event, pageId) {
                    _this.$mdDialog.show(_this.$mdDialog.mwConfirm()
                        .title('Are you sure you want to disconnect your account?')
                        .ok('Yes')
                        .cancel('No')).then(function () {
                        _this.status = 'loading';
                        _this.instagramService.removePage(pageId).then(function () { return _this.getPages(); });
                    }, function () {
                    });
                }
            }
        ];
        this.accountMenuItems = [
            {
                name: '',
                onClick: function ($event, pageId) {
                    _this.$mdDialog.show({
                        parent: angular$1.element(document.body),
                        targetEvent: $event,
                        clickOutsideToClose: true,
                        template: "<wc-instagram-activity-log [config]=\"config\"></wc-instagram-activity-log>",
                        locals: {
                            config: {
                                sources: _this.sources
                            }
                        },
                        controller: ['$scope', '$mdDialog', 'config', DialogController]
                    }).then(function () {
                    });
                    function DialogController($scope, $mdDialog, config) {
                        $scope.config = config;
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        };
                    }
                }
            }
        ];
        /* Start Angular Lifecycle Methods (https://hotell.gitbooks.io/ng-metadata/content/docs/api/core/interface.html) */
        this.ngOnInit = function () {
            _this.getAllTranslations();
            if (_this.wildcardConfig.APP_ENV === 'dev') {
                _this.initFacebook();
            }
            else {
                FB.init({
                    appId: _this.wildcardConfig.FB_APP_ID,
                    autoLogAppEvents: true,
                    xfbml: true,
                    version: 'v3.2'
                });
            }
            _this.getPages();
            // need to wire up to facebook event listener
            _this.$window.addEventListener('facebook-login-callback', function (event) {
                _this.authenticate(event, null);
            });
        };
        /* End Angular Lifecycle Methods */
        /* Start Custom Methods */
        this.getPages = function () {
            _this.instagramService.getPagesForCurrentCompany('').then(_this.gotPages);
        };
        this.gotPages = function (response) {
            var pages = response.data.data;
            for (var i = 0; i < pages.length; i++) {
                var tokens = response.data.data[i].tokens;
                pages[i].should_reconnect = _this.shouldReconnnect(tokens[0]);
                pages[i].expiry_text = _this.formatExpiryDate(tokens[0]);
            }
            _this.sources = response.data.data;
            _this.status = 'success';
        };
        /* Should this go to the instagram service or a FB service */
        this.authenticate = function ($event) {
            var that = _this;
            FB.getLoginStatus(function (response) {
                var that2 = that;
                if (response.status === 'connected' && response.authResponse) {
                    var accessToken_1 = response.authResponse.accessToken;
                    var fbUserId_1 = response.authResponse.userID;
                    that2.instagramService.auth(fbUserId_1, accessToken_1, '').then(function (response) {
                        if (response.data.data) {
                            var pages = response.data.data;
                            var next = '';
                            if (response.data.next) {
                                next = response.data.next;
                            }
                            if (pages.length > 0) {
                                that2.monitorConnectProfilesModal(event, pages, fbUserId_1, accessToken_1, next);
                            }
                            else {
                                that2.popToast('Your user does not have rights to a Facebook Page that is connected to an Instagram' +
                                    ' Business Account, please follow these steps https://help.instagram.com/1717693135113805 and' +
                                    ' try again.');
                            }
                        }
                        else if (response.data.error) {
                            that.popToast(response.data.error[0].message);
                        }
                    });
                }
                else {
                    that2.popToast('User cancelled login or did not fully authorize.');
                }
            }, true);
        };
        this.reconnect = function ($event, connectedPage) {
            var that = _this;
            FB.login(function (response) {
                var that2 = that;
                if (response.status === 'connected' && response.authResponse) {
                    var accessToken = response.authResponse.accessToken;
                    var fbUserId = response.authResponse.userID;
                    that2.instagramService.updateToken(connectedPage.page.id, fbUserId, accessToken).then(function (response) {
                        var pageData = response.data.data;
                        connectedPage.page = pageData.page;
                        connectedPage.tokens = pageData.tokens;
                        connectedPage.expiry_text = that.formatExpiryDate(pageData.tokens[0]);
                        connectedPage.should_reconnect = false;
                    }, function (errorResponse) {
                        that2.popToast('Your user does not have rights to a Facebook Page that is connected to an Instagram' +
                            ' Business Account, please follow these steps https://help.instagram.com/1717693135113805 and' +
                            ' try again.');
                    });
                }
                else {
                    that2.popToast('User cancelled login or did not fully authorize.');
                }
            }, { scope: 'manage_pages,instagram_basic,instagram_manage_insights' });
        };
        this.popToast = function (message) {
            _this.$mdToast.show(_this.$mdToast.mwSingleActionTimed()
                .textContent(message)
                .action('Close')
                .hideDelay(0)
                .parent(angular$1.element(document.getElementsByTagName('wc-instagram-sources'))));
        };
        this.instagramService = new InstagramService(this.$http);
    }
    InstagramSourcesComponent.prototype.ngAfterViewInit = function () {
        // Called after this controller's element and its children have been linked, do any DOM initialization here
    };
    
    InstagramSourcesComponent.prototype.ngOnChanges = function (changes) {
        // Called whenever one-way bindings are updated.
    };
    
    InstagramSourcesComponent.prototype.ngOnDestroy = function () {
        // Called when containing scope is destroyed. Use this hook for releasing external resources, watches and event handlers.
    };
    
    /* Create service to wrap modal setup */
    InstagramSourcesComponent.prototype.monitorConnectProfilesModal = function ($event, profiles, fbUserId, accessToken, next) {
        var _this = this;
        this.$mdDialog.show({
            parent: angular$1.element(document.body),
            targetEvent: $event,
            template: '<wc-instagram-connect-profile [config] = "config"></wc-instagram-business-accounts>',
            locals: {
                config: {
                    profiles: profiles,
                    fbUserId: fbUserId,
                    accessToken: accessToken,
                    next: next
                }
            },
            controller: ['$scope', '$mdDialog', 'config', DialogController]
        }).then(function () {
            _this.getPages();
        });
        function DialogController($scope, $mdDialog, config) {
            $scope.config = config;
            $scope.closeDialog = function () {
                $mdDialog.hide();
            };
        }
    };
    
    InstagramSourcesComponent.prototype.formatExpiryDate = function (token) {
        var text = '';
        if (!token.is_valid) {
            text = 'Expired';
        }
        else {
            var someDate = token.token_expiry;
            /*
            * Changes to avoid Safari issues due to its strict ISO 8601 following
            *
            * Drop seconds after the decimal
            * Replace - with /
            * */
            var preformattedDate = someDate.substring(0, someDate.indexOf('.')).replace(/-/g, '/');
            var date = new Date(preformattedDate);
            var today = new Date();
            var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            var days = Math.floor((date.getTime() - today.getTime()) / 86400000);
            if (days < 0) {
                text = 'Expired ';
            }
            else if (days === 0) {
                text = 'Expires today ';
            }
            else if (days === 1) {
                text = 'Expires in 1 day ';
            }
            else {
                text = 'Expires in ' + days + ' days ';
            }
            text += '(' + monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear() + ')';
        }
        return text;
    };
    
    InstagramSourcesComponent.prototype.shouldReconnnect = function (token) {
        if (!token.is_valid) {
            return true;
        }
        var someDate = token.token_expiry;
        var date = new Date(someDate);
        var today = new Date();
        var days = Math.floor((date.getTime() - today.getTime()) / 86400000);
        return days < 10;
    };
    // This was to work around bug where we missed the rendering step of fairhair.
    InstagramSourcesComponent.prototype.initFacebook = function () {
        // Only initialize FB SDK if parent app has not already
        if (!this.$window.FB) {
            // Move this to instagram module
            this.$window.fbAsyncInit = function () {
                FB.init({
                    appId: '2038074726483303',
                    autoLogAppEvents: true,
                    xfbml: true,
                    version: 'v3.2'
                });
            };
            (function (d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {
                    return;
                }
                js = d.createElement(s);
                js.id = id;
                js.src = 'https://connect.facebook.net/en_US/sdk.js';
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
        }
    };
    
    InstagramSourcesComponent.prototype.getAllTranslations = function () {
        var _this = this;
        // Get description Text
        this.$translate([
            'mw-instagram-connect__sources--description-bullet-1',
            'mw-instagram-connect__sources--description-bullet-2'
        ]).then(function (translations) {
            _this.descriptionText.bullets = Object.values(translations);
        });
        // Get menu Items
        // Need to update translations in library before re-implementing
        /*this.$translate([
            'mw-instagram-connect__sources--menu-item-1',
            'mw-instagram-connect__sources--menu-item-2',
            'mw-instagram-connect__sources--menu-item-3'
        ]).then(translations => {
            const values = Object.values(translations)
            for (let i = 0; i < this.hamburgerMenuItems.length; i++) {
                this.hamburgerMenuItems[i].name = values[i];
            }
            //this.hamburgerMenuItems.map(item => )
        });*/
        // Get account menu Items
        this.$translate([
            'mw-instagram-connect__sources--account-menu-item-1'
        ]).then(function (translations) {
            var values = Object.values(translations);
            for (var i = 0; i < _this.accountMenuItems.length; i++) {
                _this.accountMenuItems[i].name = values[i];
            }
        });
    };
    InstagramSourcesComponent = __decorate$1([
        core.Component({
            selector: 'wc-instagram-sources',
            template: "\n        <!-- Header -->\n        <div layout=\"column\">\n            <div layout=\"row\">\n                <div>\n                    <h4 translate=\"mw-instagram-connect__sources--header\"></h4>\n                </div>\n                <!-- Facebook Button -->\n                <div flex layout=\"row\" layout-align=\"end center\">\n                    <div\n                            class=\"fb-login-button\"\n                            data-max-rows=\"1\"\n                            data-size=\"medium\"\n                            data-button-type=\"continue_with\"\n                            data-use-continue-as=\"true\"\n                            data-scope=\"manage_pages,instagram_basic,instagram_manage_insights\"\n                            data-on-login=\"let event = new Event('facebook-login-callback'); this.dispatchEvent(event)\"\n                    ></div>\n\n                    <md-menu class=\"mw-menu\" md-position-mode=\"target-left target\" md-offset=\"0 50\" style=\"margin-left: 5px;\">\n                        <mw-menu-trigger-icon-button icon=\"navigation:ic_more_vert_24px\" tooltip=\"{{'Open Menu' | translate}}\"\n                                                     on-click=\"$mdOpenMenu($event)\"></mw-menu-trigger-icon-button>\n                        <md-menu-content class=\"mw-menu-dropdown\" md-padding=\"md-padding\">\n                            <mw-menu-item ng-repeat=\"item in $ctrl.accountMenuItems\"\n                                          ng-click=\"item.onClick($event,source.page.id)\"\n                            >{{item.name}}\n                            </mw-menu-item>\n                        </md-menu-content>\n                    </md-menu>\n                </div>\n            </div>\n\n            <div layout=\"column\" style=\"color: gray;\">\n                <label translate=\"mw-instagram-connect__sources--description-title\"></label>\n                <ul>\n                    <li ng-repeat=\"bullet in $ctrl.descriptionText.bullets\" style=\"margin: 10px; margin-left: 35px\">{{bullet}}\n                    </li>\n                </ul>\n            </div>\n        </div>\n\n        <!-- Sources Container -->\n        <div>\n            <!-- Repeat over sources if they exist -->\n            <div ng-if=\"$ctrl.sources.length > 0\" ng-repeat=\"source in $ctrl.sources\">\n\n                <md-divider></md-divider>\n\n\n                <div layout=\"row\" layout-align=\"center center\" style=\"padding: 10px 0;\">\n\n                    <!-- Left Side (Source Detail) -->\n                    <div flex layout=\"row\">\n\n                        <!-- Image -->\n                        <div flex style=\"max-width: 70px; padding-right: 5px;\">\n                            <img src=\"https://instagram-brand.com/wp-content/uploads/2016/11/app-icon2.png\"\n                                 height=\"60px\"\n                                 style=\"margin-top: 7px;\"/>\n                        </div>\n\n                        <!-- Content -->\n                        <div flex layout=\"column\" style=\"margin-left: 10px;\">\n                            <label>{{source.page.ig_business_profile_name}}</label>\n                            <div flex style=\"font-size: 12px;  color: gray; margin-top: 8px;\">\n                                <div>\n                                    <img style=\"width:11px\"\n                                         src=\"https://en.facebookbrand.com/wp-content/uploads/2016/05/flogo_rgb_hex-brc-site-250.png\"\n                                         translate=\"mw-instagram-connect__sources--connected-to\"\n                                    ><a\n                                        style=\"color: gray;font-weight: bold;text-decoration: none;\"\n                                        href=\"{{source.page.fb_page_link}}\"\n                                > {{source.page.fb_page_name}}</a>\n                                </div>\n                                <div\n                                        style=\"margin-top: 3px;\"\n                                >Connected By: <b>{{source.page.fb_page_name}}</b>\n                                </div>\n                                <div style=\"margin-top: 3px;\"> <!-- I Think We need to simplify for translations-->\n                                    Competitors: {{source.page.profiles.length}} \u2022 Hashtags: {{source.page.fb_hashtags_count}}\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n\n                    <!-- Right Side (Action Items) -->\n                    <div layout=\"column\">\n                        <!-- Top Row -->\n                        <div flex layout=\"row\" layout-align=\"end center\">\n                            <div>\n                                <md-button ng-show=\"source.should_reconnect\"\n                                           ng-click=\"$ctrl.reconnect($event, source)\"\n                                           class=\"mw-button mw-button--outlined mw-button--slim\"\n                                           translate=\"mw-instagram-connect__sources--reconnect-button\"\n                                >\n                                </md-button>\n                                <span style=\"color:#28bbbb;font-size:12px;font-weight: 400; margin-right: 5px;text-transform: uppercase;\"\n                                      ng-hide=\"source.should_reconnect\"\n                                      translate=\"mw-instagram-connect__sources--connected-status\"\n                                ></span>\n                            </div>\n\n                            <md-menu class=\"mw-menu\" md-position-mode=\"target-left target\" md-offset=\"0 50\">\n                                <mw-menu-trigger-icon-button icon=\"navigation:ic_more_vert_24px\" tooltip=\"{{'Open Menu' | translate}}\"\n                                                             on-click=\"$mdOpenMenu($event)\"></mw-menu-trigger-icon-button>\n                                <md-menu-content class=\"mw-menu-dropdown\" md-padding=\"md-padding\">\n                                    <mw-menu-item ng-repeat=\"item in $ctrl.hamburgerMenuItems\"\n                                                  ng-click=\"item.onClick($event,source.page.id)\"\n                                    >{{item.name}}\n                                    </mw-menu-item>\n                                </md-menu-content>\n                            </md-menu>\n                        </div>\n\n                        <!-- Bottom Row -->\n                        <div flex layout=\"row\" layout-align=\"end center\">\n                            <label style=\"font-size: 12px; color: gray; padding-right: 43px;\"\n                                   ng-style=\"{true: {color: 'red'}}[source.should_reconnect]\">\n                                {{ source.expiry_text }}\n                            </label>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <!-- Show message if no sources exist -->\n            <div ng-if=\"$ctrl.sources.length === 0\" layout=\"row\" layout-align=\"center center\">\n                <h3 translate=\"mw-instagram-connect__sources--account-error\"></h3>\n            </div>\n        </div>\n\n        <!-- Loading Spinner -->\n        <div ng-if=\"$ctrl.status === 'loading'\">\n            <mw-loader></mw-loader>\n        </div>\n    "
        }),
        __param(0, core.Inject('$scope')),
        __param(1, core.Inject('$mdDialog')),
        __param(2, core.Inject('$timeout')),
        __param(3, core.Inject('$mdMedia')),
        __param(4, core.Inject('$mdToast')),
        __param(5, core.Inject('$window')),
        __param(6, core.Inject('$http')),
        __param(7, core.Inject('$translate')),
        __param(8, core.Inject('$q')),
        __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object, Object, Object, Object, InstagramService])
    ], InstagramSourcesComponent);
    return InstagramSourcesComponent;
}());

var __decorate$4 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$3 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param$2 = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var InstagramManageItemsComponent = /** @class */ (function () {
    function InstagramManageItemsComponent($scope, $mdDialog, $timeout, $mdMedia, $mdToast, $filter, $http, $attrs, instagramService) {
        'ngInject';
        var _this = this;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.$timeout = $timeout;
        this.$mdMedia = $mdMedia;
        this.$mdToast = $mdToast;
        this.$filter = $filter;
        this.$http = $http;
        this.$attrs = $attrs;
        this.instagramService = instagramService;
        this.fetchStatus = 'loading';
        this.trackedItem = '';
        this.height = 200;
        this.infotip = {
            created: 'Instagram allows verified business to query a maximum of 30 unique hashtags within a rolling, seven-day period. This' +
                ' limit is cumulative across all apps where your account is connected to conduct searches. Be sure to sync up with your' +
                ' account admins :)',
            hashtagInfo: 'Find conversations about your brand, campaign or influential industry topics. Search against the content to' +
                ' discover your share of voice. Note that Instagram now limits hashtag searches to verified business accounts, and only' +
                ' 30 hashtags per account.',
            competitorInfo: 'Track your brand\'s extentions (such as country handles), competitors or influencers in your industry. Only' +
                ' verified business accounts can follow other verified business accounts.',
            header: ''
        };
        this.facebookHashtagCount = 0;
        this.requestPending = false;
        this.clientSideValidate = function (itemValue) {
            var filterdItems = _this.currentItems.filter(function (e) { return e.id === itemValue; });
            return !filterdItems.length > 0;
        };
        this.validate = function () {
            if (!_this.clientSideValidate(_this.trackedItem)) {
                _this.popToast('Item already added.');
            }
            else {
                _this.requestPending = true;
                _this.instagramService.addItem(_this.pageId, _this.itemType, _this.trackedItem).then(function (response) {
                    _this.requestPending = false;
                    _this.validationDone(response);
                }).catch(function (error) {
                    _this.requestPending = false;
                    _this.popToast('Whoops, something went wrong');
                });
            }
        };
        this.validationDone = function (response) {
            var data = response.data;
            if (data.success === false) {
                _this.validationError(data.error);
            }
            else {
                _this.currentItems.unshift(data.data);
                _this.facebookHashtagCount = data.fb_hashtags_count;
            }
        };
        this.validationError = function (errors) {
            for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
                var error = errors_1[_i];
                _this.popToast(error.message);
                break;
            }
        };
        this.getCurrentItems = function () {
            _this.fetchStatus = 'loading';
            _this.instagramService.getItemsForPage(_this.pageId, _this.itemType).then(_this.gotCurrentItems);
        };
        this.gotCurrentItems = function (response) {
            _this.fetchStatus = 'success';
            for (var _i = 0, _a = response.data.data; _i < _a.length; _i++) {
                var p = _a[_i];
                p.selected = true;
            }
            _this.currentItems = response.data.data;
            _this.facebookHashtagCount = response.data.fb_hashtags_count;
        };
        this.close = function () {
            _this.$mdDialog.hide();
        };
        this.save = function ($event) {
            // this was intended for hashtags but is now being used for business accounts too need to update variable names
            var deletedHashtags = '';
            var selectedItems = _this.currentItems.filter(function (e) {
                if (!e.selected) {
                    if (deletedHashtags === '') {
                        if (_this.config.name === 'Hashtags') {
                            deletedHashtags = '#' + e.id;
                        }
                        else {
                            deletedHashtags = '@' + e.id;
                        }
                    }
                    else {
                        if (_this.config.name === 'Hashtags') {
                            deletedHashtags = deletedHashtags + ', #' + e.id;
                        }
                        else {
                            deletedHashtags = deletedHashtags + ', @' + e.id;
                        }
                    }
                }
                return e.selected;
            });
            var save = function () {
                _this.deletedHashtags = '';
                return _this.instagramService.saveItems(_this.pageId, _this.itemType, selectedItems).then(_this.saveItemsDone);
            };
            console.log(_this);
            if (deletedHashtags !== '') {
                _this.$mdDialog.show({
                    parent: angular$1.element(document.body),
                    targetEvent: $event,
                    multiple: true,
                    template: '<wc-instagram-confirm-dialog [config] = "config"></wc-instagram-confirm-dialog>',
                    locals: {
                        config: {
                            items: deletedHashtags,
                            type: _this.itemType
                        }
                    },
                    controller: ['$scope', '$mdDialog', 'config', DialogController]
                }).then(function (response) {
                    if (response === 'confirmed') {
                        save();
                    }
                });
                function DialogController($scope, $mdDialog, config) {
                    $scope.config = config;
                }
            }
            else {
                save();
            }
        };
        this.saveItemsDone = function (response) {
            if (response.data.success) {
                _this.close();
            }
            else {
                _this.popToast('Some error occurred');
            }
        };
        this.popToast = function (message) {
            _this.$mdToast.show(_this.$mdToast.mwSingleActionTimed()
                .textContent(message)
                .action('Close')
                .hideDelay(0)
                .parent(angular$1.element(document.getElementsByTagName('wc-instagram-manage-items'))));
        };
        this.height = 200;
        this.instagramService = new InstagramService(this.$http);
    }
    
    /* lifecycle hooks (https://hotell.gitbooks.io/ng-metadata/content/docs/api/core/interface.html) */
    InstagramManageItemsComponent.prototype.ngOnInit = function () {
        this.infotip.header = this.config.name === 'Hashtags' ? this.infotip.hashtagInfo : this.infotip.competitorInfo;
        this.pageId = this.config.pageId;
        this.itemType = this.config.itemType;
        this.getCurrentItems();
    };
    
    InstagramManageItemsComponent.prototype.ngAfterViewInit = function () {
        // Called after this controller's element and its children have been linked, do any DOM initialization here
    };
    
    InstagramManageItemsComponent.prototype.ngOnChanges = function (changes) {
        // Called whenever one-way bindings are updated.
    };
    
    InstagramManageItemsComponent.prototype.ngOnDestroy = function () {
        // Called when containing scope is destroyed. Use this hook for releasing external resources, watches and event handlers.
    };
    
    __decorate$4([
        core.Input(),
        __metadata$3("design:type", Object)
    ], InstagramManageItemsComponent.prototype, "config", void 0);
    InstagramManageItemsComponent = __decorate$4([
        core.Component({
            selector: 'wc-instagram-manage-items',
            template: "\n        <div style=\"padding:24px; width: 600px;\">\n            <!-- Header -->\n            <div>\n                <h4 ng-if=\"$ctrl.config.name === 'Hashtags'\">Manage {{$ctrl.config.name}}</h4>\n                <h4 ng-if=\"$ctrl.config.name === 'Business Profiles'\">Manage Competitors</h4>\n                <h5 style=\"color: gray; font-weight: 400; margin-bottom: 10px;\">{{$ctrl.infotip.header}}</h5>\n            </div>\n\n            <md-divider></md-divider>\n\n            <!-- Input -->\n            <div layout=\"row\">\n                <div flex>\n                    <md-input-container md-no-float style=\"margin: 5px 0; height: 40px;\">\n                        <input ng-model=\"$ctrl.trackedItem\" placeholder=\"Type {{$ctrl.config.name}}\">\n                    </md-input-container>\n                </div>\n                <div flex layout=\"column\" layout-align=\"center end\">\n                    <md-button ng-click=\"$ctrl.validate()\" class=\"mw-button\" ng-disabled=\"$ctrl.requestPending\">Add</md-button>\n                </div>\n            </div>\n\n            <md-divider></md-divider>\n            <br/>\n\n            <!-- Hashtags -->\n            <mw-modal-content class=\"mw-menu-dialog\">\n                <div ng-if=\"$ctrl.fetchStatus === 'success'\" style=\"max-height: 200px; overflow: auto;\">\n                    <div layout=\"row\" layout-align=\"start center\" ng-if=\"$ctrl.config.name === 'Hashtags'\">\n                        <h5 style=\"color: gray; text-transform: uppercase; font-weight: 400; margin: 0\">\n                            {{$ctrl.facebookHashtagCount}} of 30 created</h5>\n                        <mw-infotip\n                                text-content=\"{{$ctrl.infotip.created}}\">\n                        </mw-infotip>\n                    </div>\n                    <div layout=\"row\" layout-align=\"start center\" ng-if=\"$ctrl.config.name === 'Business Profiles'\">\n                        <h5 style=\"color: gray; text-transform: uppercase; font-weight: 400; margin: 0\">{{$ctrl.currentItems.length}}\n                            created</h5>\n                    </div>\n                    <mw-menu-item\n                            ng-repeat=\"item in $ctrl.currentItems \"\n                            is-selected=\"item.selected\"\n                            on-click=\"item.selected = !item.selected\"\n                            ng-if=\"$ctrl.config.name === 'Business Profiles'\"\n                            type=\"multiselect\"\n                    >\n                        {{item.id}}\n                    </mw-menu-item>\n\n                    <mw-menu-item\n                            ng-repeat=\"item in $ctrl.currentItems \"\n                            is-selected=\"item.selected\"\n                            on-click=\"item.selected = !item.selected\"\n                            ng-if=\"$ctrl.config.name === 'Hashtags'\"\n                            type=\"multiselect\"\n                    >\n                        #{{item.id}}\n                    </mw-menu-item>\n                </div>\n\n            </mw-modal-content>\n\n            <!-- OK Button-->\n            <div flex layout=\"row\" layout-align=\"end center\">\n                <md-button ng-click=\"$ctrl.close()\" class=\"mw-button\">Cancel</md-button>\n                <md-button ng-click=\"$ctrl.save($event)\" class=\"mw-button\">OK</md-button>\n            </div>\n\n            <!-- Loading Spinner -->\n            <div ng-if=\"$ctrl.fetchStatus === 'loading'\">\n                <mw-loader></mw-loader>\n            </div>\n        </div>\n    "
        }),
        __param$2(0, core.Inject('$scope')),
        __param$2(1, core.Inject('$mdDialog')),
        __param$2(2, core.Inject('$timeout')),
        __param$2(3, core.Inject('$mdMedia')),
        __param$2(4, core.Inject('$mdToast')),
        __param$2(5, core.Inject('$filter')),
        __param$2(6, core.Inject('$http')),
        __param$2(7, core.Inject('$attrs')),
        __metadata$3("design:paramtypes", [Object, Object, Object, Object, Object, Object, Object, Object, InstagramService])
    ], InstagramManageItemsComponent);
    return InstagramManageItemsComponent;
}());

var __decorate$5 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$4 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param$3 = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var InstagramConnectProfileComponent = /** @class */ (function () {
    function InstagramConnectProfileComponent($scope, $mdDialog, $timeout, $mdMedia, $mdToast, $filter, $http, $attrs, instagramService) {
        'ngInject';
        var _this = this;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.$timeout = $timeout;
        this.$mdMedia = $mdMedia;
        this.$mdToast = $mdToast;
        this.$filter = $filter;
        this.$http = $http;
        this.$attrs = $attrs;
        this.instagramService = instagramService;
        this.status = 'loading';
        this.selectedPage = '';
        this.height = 200;
        this.itemSelected = this.config.profiles[0].instagram_business_account.username;
        this.close = function () {
            _this.$mdDialog.hide();
        };
        this.save = function () {
            var selectedItems = _this.config.profiles.filter(function (e) { return e.instagram_business_account.username === _this.itemSelected; });
            var addPage = selectedItems[0];
            var that = _this;
            var postBody = {
                'ig_business_profile_id': addPage.instagram_business_account.id,
                'ig_business_profile_name': addPage.instagram_business_account.username,
                'fb_page_id': addPage.id,
                'fb_page_name': addPage.name,
                'fb_page_link': addPage.link,
                'fb_user_id': _this.config.fbUserId,
                'access_token': _this.config.accessToken
            };
            _this.instagramService.addPost(postBody).then(function (resp) {
                that.close();
            });
        };
        this.getAuth = function (index) {
            _this.instagramService.auth(_this.config.fbUserId, _this.config.accessToken, index).then(function (response) {
                if (response.data.data) {
                    _this.config.profiles = response.data.data;
                    _this.config.next = '';
                    if (response.data.next) {
                        _this.config.next = response.data.next;
                    }
                }
                else if (response.data.error) {
                    _this.popToast(response.data.error[0].message);
                }
            });
        };
        this.popToast = function (message) {
            _this.$mdToast.show(_this.$mdToast.mwSingleActionTimed()
                .textContent(message)
                .action('Close')
                .hideDelay(0)
                .parent(angular.element(document.getElementsByTagName('wc-instagram-connect-profile'))));
        };
        this.height = 200;
        this.instagramService = new InstagramService(this.$http);
    }
    /* lifecycle hooks (https://hotell.gitbooks.io/ng-metadata/content/docs/api/core/interface.html) */
    InstagramConnectProfileComponent.prototype.ngOnInit = function () {
    };
    InstagramConnectProfileComponent.prototype.ngAfterViewInit = function () {
        // Called after this controller's element and its children have been linked, do any DOM initialization here
    };
    InstagramConnectProfileComponent.prototype.ngOnChanges = function (changes) {
        // Called whenever one-way bindings are updated.
    };
    InstagramConnectProfileComponent.prototype.ngOnDestroy = function () {
        // Called when containing scope is destroyed. Use this hook for releasing external resources, watches and event handlers.
    };
    __decorate$5([
        core.Input(),
        __metadata$4("design:type", Object)
    ], InstagramConnectProfileComponent.prototype, "config", void 0);
    InstagramConnectProfileComponent = __decorate$5([
        core.Component({
            selector: 'wc-instagram-connect-profile',
            template: "\n        <div style=\"min-width: 400px; max-width: 800px;\">\n            <h4 \n                    style=\"padding-left:24px;padding-right:24px;\"\n                    translate=\"mw-instagram-connect__profile--header\"\n            ></h4>\n            <div style=\"margin: 0 24px; margin-bottom: 24px\">\n                <label\n                        style=\"color: gray;\"\n                        translate=\"mw-instagram-connect__profile--description\">\n                </label>\n            </div>\n            <md-divider></md-divider>\n            <mw-modal-content class=\"mw-menu-dialog\">\n                <div style=\"height: 400px;overflow-y: auto; padding-top: 20px; margin-left:20px;padding-right: 10px;\">\n                    <md-radio-group ng-model=\"$ctrl.itemSelected\" class=\"md-primary\">\n                        <md-radio-button\n                                value=\"{{item.instagram_business_account.username}}\"\n                                ng-repeat=\"item in $ctrl.config.profiles\"\n                                on-click=\"\"\n                        ><img style=\"width:13px\" src=\"https://instagram-brand.com/wp-content/uploads/2016/11/app-icon2.png\"> @{{item.instagram_business_account.username}} \n                            ( <img style=\"width:13px\" src=\"https://en.facebookbrand.com/wp-content/uploads/2016/05/flogo_rgb_hex-brc-site-250.png\"> {{item.link}} )\n                        </md-radio-button>\n                    </md-radio-group>\n                </div>\n            </mw-modal-content>\n            <div flex layout=\"row\" layout-align=\"end center\">\n                <md-button ng-click=\"$ctrl.close()\" class=\"mw-button\" translate=\"mw-instagram-connect__profile--close-button\"></md-button>\n                <md-button ng-click=\"$ctrl.save()\" class=\"mw-button\" translate=\"mw-instagram-connect__profile--save-button\"></md-button>\n                <md-button ng-click=\"$ctrl.getAuth($ctrl.config.next)\" ng-disabled=\"$ctrl.config.next === ''\" class=\"mw-button\">Next</md-button>\n            </div>\n        </div>\n    "
        }),
        __param$3(0, core.Inject('$scope')),
        __param$3(1, core.Inject('$mdDialog')),
        __param$3(2, core.Inject('$timeout')),
        __param$3(3, core.Inject('$mdMedia')),
        __param$3(4, core.Inject('$mdToast')),
        __param$3(5, core.Inject('$filter')),
        __param$3(6, core.Inject('$http')),
        __param$3(7, core.Inject('$attrs')),
        __metadata$4("design:paramtypes", [Object, Object, Object, Object, Object, Object, Object, Object, InstagramService])
    ], InstagramConnectProfileComponent);
    return InstagramConnectProfileComponent;
}());

var __decorate$6 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$5 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param$4 = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var InstagramActivityLogComponent = /** @class */ (function () {
    function InstagramActivityLogComponent($scope, $mdDialog, $timeout, $mdMedia, $mdToast, $filter, $http, $attrs, $q, instagramService) {
        'ngInject';
        var _this = this;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.$timeout = $timeout;
        this.$mdMedia = $mdMedia;
        this.$mdToast = $mdToast;
        this.$filter = $filter;
        this.$http = $http;
        this.$attrs = $attrs;
        this.$q = $q;
        this.instagramService = instagramService;
        this.fetchStatus = 'loading';
        this.selectedPage = '';
        this.height = 200;
        this.activityIndex = '';
        this.activityPageIndex = '';
        this.activityProfileFilter = 'All';
        this.profiles = [{
                'fb_page_name': 'All',
                'id': 'All'
            }];
        this.activity_types = Object.freeze({
            hashtag_add: 'Added Hashtag',
            hashtag_delete: 'Deleted Hashtag',
            page_add: 'Connected Page',
            page_reconnect: 'Reconnected Page',
            page_delete: 'Disconnected Page',
            profile_add: 'Added Competitor',
            profile_delete: 'Deleted Competitor',
        });
        this.status = 'loading';
        this.oldPageID = '';
        this.close = function () {
            _this.$mdDialog.hide();
        };
        this.getActivityByPageID = function (pageId) {
            // check to see if the pageID changed so we can reset the index and fetch logs from the beginning
            if (_this.oldPageID === '') {
                _this.oldPageID = pageId;
            }
            if (_this.oldPageID !== pageId) {
                _this.oldPageID = pageId;
                _this.activityPageIndex = '';
            }
            _this.status = 'loading';
            if (_this.activityIndex === 'reset') {
                _this.activityIndex = '';
            }
            if (pageId === 'All') {
                _this.activityIndex = '';
                _this.getActivity();
                return;
            }
            _this.instagramService.getActivityLogByPageID(pageId, _this.activityPageIndex).then(function (response) {
                if (response.data) {
                    _this.status = 'success';
                    if (response.data.next) {
                        _this.activityPageIndex = response.data.next;
                    }
                    else {
                        _this.activityPageIndex = 'reset';
                    }
                    _this.fetchStatus = 'success';
                    // This should be in the service so we have a data transform layer
                    response.data.data.map(function (entry) {
                        /*
                        * Changes to avoid Safari issues due to its strict ISO 8601 following
                        *
                        * Drop seconds after the decimal
                        * Replace - with /
                        * */
                        var preformattedDate = entry.created_at.substring(0, entry.created_at.indexOf('.')).replace(/-/g, '/');
                        var date = new Date(preformattedDate + ' UTC');
                        entry.created_at = date.toLocaleDateString(navigator.language) + ' ' + date.toLocaleTimeString(navigator.language);
                        entry.activity_type = _this.activity_types[entry.activity_type];
                        return entry;
                    });
                    _this.activityLog = response.data.data;
                }
                else {
                }
            });
        };
        this.getActivity = function () {
            _this.status = 'loading';
            if (_this.activityPageIndex === 'reset') {
                _this.activityPageIndex = '';
            }
            _this.instagramService.getActivityLog(_this.activityIndex).then(function (response) {
                if (response.data) {
                    _this.status = 'success';
                    if (response.data.next) {
                        _this.activityIndex = response.data.next;
                    }
                    else {
                        _this.activityIndex = 'reset';
                    }
                    _this.fetchStatus = 'success';
                    // This should be in the service so we have a data transform layer
                    response.data.data.map(function (entry) {
                        /*
                        * Changes to avoid Safari issues due to its strict ISO 8601 following
                        *
                        * Drop seconds after the decimal
                        * Replace - with /
                        * */
                        var preformattedDate = entry.created_at.substring(0, entry.created_at.indexOf('.')).replace(/-/g, '/');
                        var date = new Date(preformattedDate + ' UTC');
                        entry.created_at = date.toLocaleDateString(navigator.language) + ' ' + date.toLocaleTimeString(navigator.language);
                        entry.activity_type = _this.activity_types[entry.activity_type];
                        return entry;
                    });
                    _this.activityLog = response.data.data;
                }
                else {
                }
            });
        };
        this.height = 200;
        this.instagramService = new InstagramService(this.$http);
    }
    /* lifecycle hooks (https://hotell.gitbooks.io/ng-metadata/content/docs/api/core/interface.html) */
    InstagramActivityLogComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.config && this.config.sources) {
            this.config.sources.map(function (source) {
                _this.profiles.push({
                    'fb_page_name': source.page.ig_business_profile_name,
                    'id': source.page.id
                });
            });
        }
        this.getActivity();
    };
    InstagramActivityLogComponent.prototype.ngAfterViewInit = function () {
        // Called after this controller's element and its children have been linked, do any DOM initialization here
    };
    InstagramActivityLogComponent.prototype.ngOnChanges = function (changes) {
        // Called whenever one-way bindings are updated.
    };
    InstagramActivityLogComponent.prototype.ngOnDestroy = function () {
        // Called when containing scope is destroyed. Use this hook for releasing external resources, watches and event handlers.
    };
    __decorate$6([
        core.Input(),
        __metadata$5("design:type", Object)
    ], InstagramActivityLogComponent.prototype, "config", void 0);
    InstagramActivityLogComponent = __decorate$6([
        core.Component({
            selector: 'wc-instagram-activity-log',
            template: "\n        <div style=\"min-width: 500px; width: 95%; padding: 16px;\">\n            <h4\n                    style=\"padding-left:16px;padding-right:24px;\"\n                    translate=\"mw-instagram-connect__sources--account-menu-item-1\"\n            ></h4>\n            <div flex layout=\"row\" layout-align=\"start center\" style=\"margin-left: 16px;\">\n                <md-menu class=\"mw-menu\" md-position-mode=\"target-left target\" md-offset=\"0 50\">\n                    <mw-menu-trigger-button class=\"mw-menu-trigger-button--outlined\" \n                                            tooltip=\"{{'Open Menu' | translate}}\"\n                                            on-click=\"$mdOpenMenu($event)\">\n                        {{$ctrl.activityProfileFilter}}\n                    </mw-menu-trigger-button>\n                    <md-menu-content class=\"mw-menu-dropdown\" md-padding=\"md-padding\">\n                        <mw-menu-item type=\"focusdummy\" md-autofocus></mw-menu-item>\n                        <mw-menu-item ng-repeat=\"profile in $ctrl.profiles\"\n                                      type=\"singleselect\"\n                                      is-selected=\"profile.fb_page_name === $ctrl.activityProfileFilter\"\n                                      on-click=\"$ctrl.activityProfileFilter = profile.fb_page_name; $ctrl.getActivityByPageID(profile.id)\">{{profile.fb_page_name}}</mw-menu-item>\n                    </md-menu-content>\n                </md-menu>\n            </div>\n\n            <br>\n\n            <div flex style=\" height: 355px; overflow-y: scroll;\">\n                <md-content style=\"background-color: transparent;\">\n                    <md-list flex ng-repeat=\"entry in $ctrl.activityLog\">\n                        <label style=\"padding-left: 16px; font-size: 14px; font-weight: 500; color: gray\">{{entry.created_at}}</label>\n                        <md-list-item ng-if=\"entry.activity_type === 'Added Hashtag'\"><span style=\"padding-bottom: 12px\"><b>{{entry.page_name}}</b> is now tracking <b>#{{entry.metadata.hashtag}}</b>. Added by <b style=\"text-transform: capitalize\">{{entry.user_name}}</b></span></md-list-item>\n                        <md-list-item ng-if=\"entry.activity_type === 'Deleted Hashtag'\"><span style=\"padding-bottom: 12px\"><b>{{entry.page_name}}</b> is no longer tracking <b ng-repeat=\"hashtag in entry.metadata.hashtags\">#{{hashtag}} </b>. Removed by <b style=\"text-transform: capitalize\">{{entry.user_name}}</b></span></md-list-item>\n                        <md-list-item ng-if=\"entry.activity_type === 'Connected Page'\"><span style=\"padding-bottom: 12px\"><b>{{entry.company_name}}</b> connected account <b>{{entry.page_name}}</b>. Added by <b style=\"text-transform: capitalize\">{{entry.user_name}}</b></span></md-list-item>\n                        <md-list-item ng-if=\"entry.activity_type === 'Reconnected Page'\"><span style=\"padding-bottom: 12px\"><b>{{entry.company_name}}</b> reconnected account <b>{{entry.page_name}}</b>. Added by <b style=\"text-transform: capitalize\">{{entry.user_name}}</b></span></md-list-item>\n                        <md-list-item ng-if=\"entry.activity_type === 'Disconnected Page'\"><span style=\"padding-bottom: 12px\"><b>{{entry.company_name}}</b> disconnected account <b>{{entry.page_name}}</b>. Removed by <b style=\"text-transform: capitalize\">{{entry.user_name}}</b></span></md-list-item>\n                        <md-list-item ng-if=\"entry.activity_type === 'Added Competitor'\"><span style=\"padding-bottom: 12px\"><b>{{entry.page_name}}</b> is now tracking the competitor <b>@{{entry.metadata.profile}}</b>. Added by <b style=\"text-transform: capitalize\">{{entry.user_name}}</b></span></md-list-item>\n                        <md-list-item ng-if=\"entry.activity_type === 'Deleted Competitor'\"><span style=\"padding-bottom: 12px\"><b>{{entry.page_name}}</b> is no longer tracking the competitors <b ng-repeat=\"profile in entry.metadata.profiles\">@{{profile}} </b>. Removed by <b style=\"text-transform: capitalize\">{{entry.user_name}}</b></span></md-list-item>\n                        <md-divider></md-divider>\n                    </md-list>\n                </md-content>\n\n            </div>\n\n            <!-- Loading Spinner -->\n            <div ng-if=\"$ctrl.status === 'loading'\">\n                <mw-loader></mw-loader>\n            </div>\n\n            <div flex layout=\"row\" layout-align=\"end center\">\n                <md-button ng-click=\"$ctrl.close()\" class=\"mw-button\" translate=\"mw-instagram-connect__profile--close-button\"></md-button>\n                <md-button ng-if=\"$ctrl.activityProfileFilter === 'All'\" ng-click=\"$ctrl.getActivity()\" ng-disabled=\"$ctrl.activityIndex === 'reset' || $ctrl.activityPageIndex === 'reset'\" class=\"mw-button\">Next</md-button>\n                <md-button ng-if=\"$ctrl.activityProfileFilter !== 'All'\" ng-click=\"$ctrl.getActivityByPageID($ctrl.oldPageID)\" ng-disabled=\"$ctrl.activityIndex === 'reset' || $ctrl.activityPageIndex === 'reset'\" class=\"mw-button\">Next</md-button>\n            </div>\n        </div>\n    "
        }),
        __param$4(0, core.Inject('$scope')),
        __param$4(1, core.Inject('$mdDialog')),
        __param$4(2, core.Inject('$timeout')),
        __param$4(3, core.Inject('$mdMedia')),
        __param$4(4, core.Inject('$mdToast')),
        __param$4(5, core.Inject('$filter')),
        __param$4(6, core.Inject('$http')),
        __param$4(7, core.Inject('$attrs')),
        __param$4(8, core.Inject('$q')),
        __metadata$5("design:paramtypes", [Object, Object, Object, Object, Object, Object, Object, Object, Object, InstagramService])
    ], InstagramActivityLogComponent);
    return InstagramActivityLogComponent;
}());

var __decorate$7 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$6 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param$5 = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var InstagramActivityConfirmDialogComponent = /** @class */ (function () {
    function InstagramActivityConfirmDialogComponent($scope, $mdDialog, $timeout, $mdMedia, $mdToast, $filter, $http, $attrs, $window) {
        'ngInject';
        var _this = this;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.$timeout = $timeout;
        this.$mdMedia = $mdMedia;
        this.$mdToast = $mdToast;
        this.$filter = $filter;
        this.$http = $http;
        this.$attrs = $attrs;
        this.$window = $window;
        this.status = 'loading';
        this.selectedPage = '';
        this.height = 200;
        this.close = function () {
            _this.$mdDialog.hide();
        };
        this.save = function () {
            _this.$mdDialog.hide('confirmed');
        };
        this.openHelpArticle = function () {
            // In dev mode, we wont have access to _elev, that is part of the fairhair app
            if (_this.$window._elev) {
                _this.$window._elev.openArticle('82511');
            }
            else {
                _this.$window.open('https://app.meltwater.com/settings/account?data-elevio-article=82511', '_blank');
            }
        };
        this.height = 200;
    }
    /* lifecycle hooks (https://hotell.gitbooks.io/ng-metadata/content/docs/api/core/interface.html) */
    InstagramActivityConfirmDialogComponent.prototype.ngOnInit = function () {
    };
    InstagramActivityConfirmDialogComponent.prototype.ngAfterViewInit = function () {
        // Called after this controller's element and its children have been linked, do any DOM initialization here
    };
    InstagramActivityConfirmDialogComponent.prototype.ngOnChanges = function (changes) {
        // Called whenever one-way bindings are updated.
    };
    InstagramActivityConfirmDialogComponent.prototype.ngOnDestroy = function () {
        // Called when containing scope is destroyed. Use this hook for releasing external resources, watches and event handlers.
    };
    __decorate$7([
        core.Input(),
        __metadata$6("design:type", Object)
    ], InstagramActivityConfirmDialogComponent.prototype, "config", void 0);
    InstagramActivityConfirmDialogComponent = __decorate$7([
        core.Component({
            selector: 'wc-instagram-confirm-dialog',
            template: "\n        <div style=\"min-width: 400px; max-width: 800px; padding: 20px 0;\">\n            <h4 style=\"padding-left:24px;padding-right:24px;\">Are you sure you want to delete the following <span\n                    ng-if=\"$ctrl.config.type === 'hashtags'\">hashtags</span><span\n                    ng-if=\"$ctrl.config.type !== 'hashtags'\">business accounts</span>?</h4>\n            <h5 ng-if=\"$ctrl.config.type === 'hashtags'\"\n                style=\"color: gray; font-weight: 400; margin-bottom: 10px; max-width: 425px; margin-left: 24px;\">Instagram hashtags are\n                saved for a rolling 7 days, deleting the selected hashtag may not immediately increase your quota, due to this platform\n                restriction. <a href=\"\" ng-click=\"$ctrl.openHelpArticle()\">Learn More</a></h5>\n            <mw-modal-content class=\"mw-menu-dialog\">\n                <md-divider></md-divider>\n\n                <div style=\"margin: 24px;\">\n                    <label>{{$ctrl.config.items}}</label>\n                </div>\n            </mw-modal-content>\n            <div flex layout=\"row\" layout-align=\"end center\">\n                <md-button ng-click=\"$ctrl.close()\" class=\"mw-button\">Cancel</md-button>\n                <md-button ng-click=\"$ctrl.save()\" class=\"mw-button\" translate=\"mw-instagram-connect__profile--save-button\"></md-button>\n            </div>\n        </div>\n    "
        }),
        __param$5(0, core.Inject('$scope')),
        __param$5(1, core.Inject('$mdDialog')),
        __param$5(2, core.Inject('$timeout')),
        __param$5(3, core.Inject('$mdMedia')),
        __param$5(4, core.Inject('$mdToast')),
        __param$5(5, core.Inject('$filter')),
        __param$5(6, core.Inject('$http')),
        __param$5(7, core.Inject('$attrs')),
        __param$5(8, core.Inject('$window')),
        __metadata$6("design:paramtypes", [Object, Object, Object, Object, Object, Object, Object, Object, Object])
    ], InstagramActivityConfirmDialogComponent);
    return InstagramActivityConfirmDialogComponent;
}());

var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var WildcardsModule = /** @class */ (function () {
    function WildcardsModule() {
    }
    WildcardsModule = __decorate([
        core.NgModule({
            imports: ['ngMaterial'],
            declarations: [
                InstagramSourcesComponent,
                InstagramConnectProfileComponent,
                InstagramManageItemsComponent,
                InstagramActivityLogComponent,
                InstagramActivityConfirmDialogComponent
            ],
            providers: [
                InstagramService,
                WildcardConfig
            ]
        })
    ], WildcardsModule);
    return WildcardsModule;
}());
var index = angular$1.module('WildcardsModule', [
    'ngMaterial',
    core.bundle(WildcardsModule).name
]);

exports['default'] = index;
exports.InstagramSourcesComponent = InstagramSourcesComponent;
exports.InstagramManageItemsComponent = InstagramManageItemsComponent;
exports.InstagramConnectProfileComponent = InstagramConnectProfileComponent;
exports.InstagramActivityLogComponent = InstagramActivityLogComponent;
exports.InstagramService = InstagramService;
exports.WildcardConfig = WildcardConfig;

Object.defineProperty(exports, '__esModule', { value: true });

})));



/*****************
 ** WEBPACK FOOTER
 ** ./~/@meltwater/wildcards-components/wildcards-components.umd.js
 ** module id = 154
 ** module chunks = 0 1
 **/